<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center" style="width: 80px">記事ID</th>
          <th class="text-center" style="width: 80px">発注ID</th>
          <th class="text-center" style="width: 80px">ステータス</th>
          <th class="text-center" style="width: 80px">差し戻し</th>
          <th class="text-left">タイトル</th>
          <th class="text-left">ライター校了日時</th>
          <th class="text-left">最終更新日</th>
          <th class="text-left">公開日</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.id">
          <td class="text-center">
            {{ order.postId }}
          </td>
          <td class="text-center">
            {{ order.id }}
          </td>
          <td class="text-center">
            <v-chip x-small label :color="orderStatusColors[order.status]">
              {{ i18nOrderStatus(order) }}
            </v-chip>
          </td>
          <td class="text-center">
            <v-icon v-if="order.isRemanded" color="error" small>
              mdi-check-circle
            </v-icon>
          </td>
          <td class="py-2" v-if="isPostActive(order)">
            {{ order.post.title }}
          </td>
          <td class="text-center" v-else></td>
          <td>
            {{ order.completedAt | moment }}
          </td>
          <td v-if="isPostActive(order)">
            {{ order.post.updatedAt | moment }}
          </td>
          <td class="text-center" v-else></td>
          <td v-if="isPostActive(order)">
            {{ order.post.releasedOn | moment }}
          </td>
          <td class="text-center" v-else></td>
          <td class="text-center">
            <slot v-if="isPostActive(order)">
              <a
                class="editLink"
                :href="writerPostEditorUrl(selectedSiteUrlOrigin(), order)"
                target="_blank"
              >
                <v-btn class="ma-2" tile small color="primary">
                  <v-icon left small> mdi-pencil </v-icon>
                  編集
                </v-btn>
              </a>
            </slot>
            <slot v-else>
              <v-btn class="ma-2" tile small disabled>
                記事削除済み
              </v-btn>
            </slot>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import snakecaseKeys from 'snakecase-keys'
import urlUtils from '@/mixins/url_utils'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  props: {
    orders: {
      type: Array,
      required: true
    },
    site: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data: () => {
    return {
      orderStatusColors: {
        writing: 'primary',
        under_inspection: 'warning',
        under_client_inspection: 'amber',
        completed: 'success'
      },
      infiniteId: +new Date()
    }
  },
  mixins: [urlUtils],
  computed: {
    ...mapState({
      orderI18ns: (state) => state.I18n.enums.order
    })
  },
  methods: {
    referUserName (order) {
      if (!order.user) {
        return null
      } else {
        return order.user.name
      }
    },
    referCategory (postTags) {
      const category = postTags.find((el) => el['is_top_level'] == true)
      if (!category || !category.name) {
        return null
      } else {
        return category.name
      }
    },
    selectedSiteUrlOrigin () {
      if (!this.site || !this.site.id) {
        return ''
      }

      return this.site.initialDomainWithProtocol
    },
    i18nOrderStatus (order) {
      return snakecaseKeys(this.orderI18ns.status, {'deep': true})[order.status]
    },
    isPostActive (order) {
      return !!order.post
    }
  }
}
</script>

<style scoped lang="sass">
th, td
  vertical-align: middle
</style>
